import PropTypes from 'prop-types';
import React from 'react';
import cx from '../../utils/cx.js';
import MembersActionCreators from '../../actions/MembersActionCreators.js';
import MemberName from '../members/MemberName.react';
import MemberLink from '../members/MemberLink.react';
import MemberImage from '../members/MemberImage.react';
import popup from '../../../app/popup.js';
import ImageSvg from '../images/ImageSvg.react';
import modal from '../../../app/modal.js';
import get from 'lodash/get';
import VerificationBadge from '../../../../react/components/verification/VerificationBadge';

const ReactPropTypes = PropTypes;

class MessagesSectionHeader extends React.Component {
  static propTypes = {
    member: ReactPropTypes.instanceOf(Object),
  };

  static defaultProps = {
    member: null,
  };

  render() {
    const member = this.props.member;

    if (!member) {
      return null;
    }

    const self = this;

    const HeaderMemberLink = function () {
      if (!member || !member.name) {
        return null;
      }

      return (
        <MemberLink key={member._id} memberId={member._id}>
          <MemberName
            key={member._id}
            memberId={member._id}
            memberAnswerScore={member.answer_score}
          />
        </MemberLink>
      );
    };

    const HeaderMenu = function () {
      // tikai par aktīvajiem var ziņot, bloķēt
      // op.messages_more_menu - rādīt vai nerādīt izvēlni, piem. uz vecākiem IE izslēgts
      /* Šim pagaidām neatradu tulkojumu un kur tas tiek iestatīts
      if (!get(translations, 'messages.more_menu', '')) {
        return null;
      } */

      let blockItemTitle = get(translations, 'txt: Bloķēt šo lietotāju', '');
      let blockItemTitleShort = get(translations, 'txt: Bloķēt', '');
      // ja ir bloķēts, rāda atbloķēšanas tekstu
      if (member.blocked) {
        blockItemTitle = get(translations, 'txt: Atbloķēt šo lietotāju', '');
        blockItemTitleShort = get(translations, 'txt: Atbloķēt', '');
      }

      const blockUserButton = function () {
        if (member.status != 'active') {
          return null;
        }

        return (
          <a
            href="#"
            id="block-user"
            onClick={self._onClickBlockAction}
            data-tooltip={cx([
              blockItemTitle,
            ])}
            className={cx([
              'btn btn--small dib tooltip tooltip--xxl mrxs', ['btn--iconLeft btn--delete', member.blocked != true], ['btn--a', member.blocked],
            ])}
          >
            <span>{blockItemTitleShort}</span>
            {member.blocked ?
              null :
              <span className="btn-static">
                <ImageSvg svg="icon-ignore" iconClass="icon--center icon--ignore" />
              </span>
            }
          </a>
        );
      };

      /* const reportUserButton = function () {
        if (member.status != 'active') {
          return null;
        }

        return (
          <a
            href="#"
            id="report-user"
            onClick={self._onClickReport}
            data-tooltip={cx([
              get(translations, 'txt: Ziņot par pārkāpumu', ''),
            ])}
            className={cx([
              'btn btn--delete btn--small btn--iconLeft dib tooltip tooltip--xxl mrxs',
            ])}
          >
            <span>{get(translations, 'txt: Ziņot', '')}</span>
            <span className="btn-static">
              <ImageSvg svg="icon-warning" iconClass="icon--center icon--warning" />
            </span>
          </a>
        );
      }; */

      const videoCallButton = function () {
        if (member.status != 'active') {
          return null;
        }

        return (
          <a
            href="#"
            id="video-call"
            data-peer-id={member._id}
            data-tooltip={cx([
              [self.props.videoTooltip, self.props.disableVideo],
            ])}
            className={cx([
              'btn btn--a btn--small btn--iconLeft dib mrxs',
              ['hide', self.props.hideVideo],
              ['btn--disabled', self.props.disableVideo],
              ['tooltip tooltip--xxl', self.props.disableVideo],
            ])}
          >
            <span>{get(translations, 'txt: Video', '')}</span>
            <span className="btn-static">
              <ImageSvg svg="icon-camera" iconClass="icon--center icon--camera" />
            </span>
          </a>
        );
      };

      const makePdfButton = function () {
        if (member.status != 'active' && !member.deleted) {
          return null;
        }

        return (
          <a
            href="#"
            id="make-pdf"
            target="_blank"
            onClick={self._onClickPdf}
            data-peer-id={member._id}
            data-tooltip={cx([get(translations, 'txt: PDF tooltip', '')])}
            className={cx(['btn btn--a btn--small btn--iconLeft dib tooltip tooltip--xxl', ['btn--disabled', self.props.disablePDF]])}
          >
            <span>{get(translations, 'txt: PDF', '')}</span>
            <span className="btn-static">
              <ImageSvg svg="icon-notes" iconClass="icon--center icon--notes" />
            </span>
          </a>
        );
      };

      return (
        <div className="messages-main-header-more">
          {blockUserButton()}
          {/* reportUserButton() */}
          {videoCallButton()}
          {makePdfButton()}
        </div>
      );
    };

    const VerificationIcon = function () {
      if (!member || !member.verified) {
        return null;
      }

      let verifiedClassName = 'messages-main-header-verified';
      if (['deleted', 'admin'].includes(member.status)) {
        verifiedClassName += ' messages-main-header-verified--pt';
      }

      return (
        <div className={verifiedClassName}>
          <VerificationBadge />
        </div>
      );
    };

    return (
      <div className="messages-main-header">
        <div className="messages-main-header-back">
          <ImageSvg svg="icon-arrowleft" iconClass="icon--arrowLeft" />
        </div>
        <div className="messages-main-header-content">
          <div className="messages-main-header-image">
            <MemberLink key={member._id} memberId={member._id}>
              <MemberImage
                memberId={member._id}
                key={member._id}
              />
            </MemberLink>
          </div>
          <h2 className="messages-main-header-title">
            {HeaderMemberLink()}
          </h2>
          {VerificationIcon()}

        </div>
      </div>
    );
  }

  /**
   * Handler for 'onClickReport'
   */
  _onClickReport = (event) => {
    event.preventDefault();
    popup.reportMember(this.props.member._id);
  };

  /**
   * Handler for 'onClickPdf'
   */
  _onClickPdf = (event) => {
    event.preventDefault();

    if (this.props.disablePDF) {
      popup.featureMessage('pdf');
    } else {
      const member_id = this.props.member._id;
      const url = `${get(globals, 'apiWebroot', '/')}messages/create_pdf/${member_id}`;

      $.ajax({
        url,
        cache: false,
        async: true,
        success(data) {
          if (typeof data.status !== 'undefined') {
            popup.pdfSender(data.status);
          } else {
            return null;
          }
        },
        error: function (xhr, status, err) {
          console.error(this.props.url, status, err.toString());
        }.bind(this),
      });
    }
  };

  /**
   * Handler for 'onClickBlockAction'
   */
  _onClickBlockAction = () => {
    const msg = get(translations, 'txt: Vai esi pārliecināts?', '');
    const member = this.props.member;

    const callback = function (result) {
      if (result) {
        // atbloķēt
        if (member.blocked) {
          MembersActionCreators.unblock(member._id);
        }
        // bloķēt
        else {
          MembersActionCreators.block(member._id);
        }
      }
    };

    modal.confirm(msg, callback);
  };
}

module.exports = MessagesSectionHeader;
